import { DateTime } from 'luxon';
import { useContext } from "react";
import { useTranslation } from 'react-i18next';
import { Account, PensionContext } from "../../../contexts/pension-robot/PensionContext";
import { useIsJointCalculation, usePartnerIsRetiredAtPension, useSelfIsRetiredAtPension, useYearsUntilPensionPartner, useYearsUntilPensionSelf } from './usePensionDate';

const dateAfterPensionDate = (accounts: Account[] | undefined, pensionDate: DateTime) => {
    if (accounts === undefined) return false;

    return accounts.some((account) => {
        if (account.availableAt === undefined) return false;

        const availableAtDateTime = DateTime.fromISO(account.availableAt);
        if (availableAtDateTime <  pensionDate) return false;

        return true
    })
};

export const useSupplementWarning = () => {
    const { t } = useTranslation('pension');
    const {
        parameters: { supplementInfo },
    } = useContext(PensionContext);

    const isCalculcatedTogether = useIsJointCalculation();

    const yearsToPensionAgeSelf = useYearsUntilPensionSelf();
    const yearsToPensionAgePartner = useYearsUntilPensionPartner();
    
    const partnerPensionDate = DateTime.now().plus({year: yearsToPensionAgePartner});
    const selfPensionDate = DateTime.now().plus({year: yearsToPensionAgeSelf});

    const selfIsRetired = useSelfIsRetiredAtPension();
    const partnerIsIsRetired = usePartnerIsRetiredAtPension();

    const NO_WARNING = { warning: false, textNode: <></>};

    // Self check if Supplement warning
    if (yearsToPensionAgeSelf === undefined){
        return NO_WARNING;
    }

    const singleTextNode = (
        <span>
            {t('pension-cocktail-warning-supplement-single')}
            <br></br><br></br>
            {t('pension-cocktail-warning-supplement-single-2')}
        </span>
    );

    const WARNING_SINGLE = { warning: true, textNode: singleTextNode};

    const selfHasAdditionalPensionEndDateAfterPensionDate = dateAfterPensionDate(supplementInfo?.self?.accounts, selfPensionDate);
    const selfHasSupplementWaring = selfHasAdditionalPensionEndDateAfterPensionDate && selfIsRetired;
    if (!isCalculcatedTogether && selfHasSupplementWaring)
        return WARNING_SINGLE;

    // Joint calculation check, if Supplement warning
    if (!isCalculcatedTogether)
        return NO_WARNING;

    const joinCalculationTextNode = (
        <span>
            {t('pension-cocktail-warning-supplement-together')}
            <br></br><br></br>
            {t('pension-cocktail-warning-supplement-together-2')}
        </span>
    );
    const WARNING_JOINT = { warning: true, textNode: joinCalculationTextNode};

    const partnerHasAdditionalPensionEndDateAfterPensionDate = dateAfterPensionDate(supplementInfo?.partner?.accounts, partnerPensionDate);
    const partnerHasSupplementWaring = partnerHasAdditionalPensionEndDateAfterPensionDate && partnerIsIsRetired;
    if (selfHasSupplementWaring || partnerHasSupplementWaring)
        return WARNING_JOINT;

    return NO_WARNING;
}
